<template>
	<div class="header">
		<div class="container cf">
			<div class="logo">
				<router-link :to="{name:'index'}"  @click.native="selpage(1)"></router-link>
			</div>
			<div class="nav">
				<ul class="cf">
					<li>
						<router-link :to="{name:'index'}" :class="{'active':getcurrentIndex ==1}" @click.native="selpage(1)">产品中心</router-link>
					</li>
					<li>
						<router-link :to="{name:'index'}" :class="{'active':getcurrentIndex ==2}" @click.native="selpage(2)">应用工具</router-link>
					</li>
					<!-- <li>
						<router-link :to="{name:'onlineShopList'}" :class="{'active':getcurrentIndex ==3}">在线商城</router-link>
					</li> -->
				</ul>
			</div>
			<div class="headerlink" v-if="getuserName==''">
				<router-link :to="{name:'login'}">登录</router-link>
				<router-link :to="{name:'register'}">注册</router-link>
			</div>
			<div class="userinfo" v-if="getuserName!=''">
				<span class="icon icon-bell" @click="jumpNotice" >
					<span class="reddot" :class="{'w28':getmessageNum>99}" v-show="getmessageNum>0">{{getmessageNum}}</span>
				</span>
				<div class="user-headerimg">
					<img :src="getimgSrc"  @click="enterCenter" v-show="!!getimgSrc"/>
					<img src="/static/img/public/headerimg-default.png" v-show="!getimgSrc" @click="enterCenter"/>
				</div>
				<div class="welcome">
					<p>欢迎光临！</p>
					<el-tooltip :content="getshowName" placement="bottom" effect="light">
						<p class="username"  @click="enterCenter">{{getshowName}}</p>
					</el-tooltip>
				</div>
			    <button class="quitbtn btn" @click="exit">退出</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	export default{
		name: 'zHeader',
		inject:['reload'],
		data () {
		    return {
		    	username:"",
          showName:"",
          usertype:"",
		    	unreadNum:null,//未读消息数

		    }
		},
		mounted:function(){
			if(this.getusertype!=""){
				this.getUnreadNum();
			}
			this.$store.commit("setcurrentIndex",1);
		},
		methods:{
			exit(){
				window.localStorage.removeItem("TOKENID");
				this.$store.commit("setuserName","");
				this.$store.commit("setshowName","");
				this.$store.commit("settoken","");
				this.$store.commit("setmessageNum","");
				this.$store.commit("setusertype","");
				this.$store.commit("setimgSrc","");
				this.$store.commit("setregType","");
				this.$router.push({path:"/index"});
				this.$store.commit("setcurrentIndex",1);
			},
			jumpNotice(){
				if (this.getusertype=="company")
				{
					this.$router.push("/companyCenter-notice");
					return true;
				}
				this.$router.push("/userCenter-info");
			},
			enterCenter(){
				this.$store.commit("setcurrentIndex",4);
				if (this.getusertype=="company")
				{
					this.$router.push("/companyCenter-userManage");
					return true;
				}
				this.$router.push("/userCenter-manage");
			},
			getUnreadNum(){
				let url="";
				if (this.getusertype=="company"){
					url="/corp/message/num";
				}else{
					url="/uc/message/NotReadMsgNum";
				}
				this.$ajax.post(url).then((res) => {
					if(res.state.value==0){
						this.unreadNum=res.result;
						this.$store.commit('setmessageNum',this.unreadNum);
					}
		        })
		        .catch((err) => {
		            console.log(err);
		        });
			},
			selpage(num){
				this.$store.commit("setcurrentIndex",num);
			}
		},
		computed: {
			...mapGetters([
		        'getimgSrc',
		        'getuserName',
				'getshowName',
				'getmessageNum',
				'getcurrentIndex',
				'getusertype'
		    ])
	    }
	}
</script>

<style scoped="scoped">
.w28{width: 28px;}
@media (max-width: 1340px){
	.headerlink{float: right;margin:0 80px 0 0;}
	.userinfo{float: right;margin:0 80px 0 0;}
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue